<template>
  <div>
    <BigTitle :bigtitle="bigtitle"></BigTitle>
    <!-- 考核指标 -->
    <Indicators :userList="assessTargetList"></Indicators>
  </div>
</template>
<script>
import BigTitle from '../bigTitle';
import Indicators from './indicators';
import { indexLeft } from '@/api/indexLeft';
import { dataInterface } from '@/api/dataInterfaceApi';

export default {
  data () {
    return {
      options: {},
      bigtitle:{
        CHN:'考核指标',
        ENG:'Evaluation index'
      },
      assessTargetList:[{
        counts:'',
        text:"运营业务收入（元）",
        percent:""
      },{
        counts:'',
        text:"运营站点数量（座）",
        percent:""
      },{
        counts:'',
        text:"车辆新增入网数（辆）",
        percent:""
      }]
    };
  },
  components: {
    BigTitle,
    Indicators
  },
  props: {
    // userList: {
    //   type: Object,
    //   default: () => ({})
    // },
  },
  watch: {
    
  },
  mounted () {
  },
  methods: {
    getData(data){
      this.selectAssessTarget(data);
    },
    selectAssessTarget(data={}){
      let _this = this;
      let params = {};
			if(data){
				//省市区
        params = {
					"enCode":"TiDB-shengshiqu-yunyingzhibiaoshouru",
    			"@province":data.province||data.city||data.district
				}
			}else {
				params = {
					"enCode":"TiDB-quanguo-yunyingzhibiaoshouru",//TiDB-全国-运营指标收入
				}
			}

      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if(!res) return;
          res = res[0];
          _this.$set(this.assessTargetList,0,{
            counts:res.Revenue,
            text:"本月运营业务收入（元）",
            percent:'+0.00%'
          })
          _this.$set(this.assessTargetList,1,{
            counts:res.StationNum,
            text:"本月新增站点数量（座）",
            percent:'+0.00%'
          })
          _this.$set(this.assessTargetList,2,{
            counts:res.VehicleAccess,
            text:"本月车辆新增入网数（辆）",
            percent:'+0.00%'
          })
          
        })
        .catch((err) => {
          console.log(err);
        });
      
    },
  }
}
</script>
<style lang="scss" scoped>

</style>